import React from "react";
import Tooltip from "@mui/material/Tooltip";
export default function AppButton({
  className,
  text,
  onClick,
  style,
  leftIcon,
  disabled,
  type,
  form,
  tooltip,
  tooltipPlacement = "top",
}) {
  if (tooltip)
    return (
      <Tooltip arrow title={tooltip} placement={tooltipPlacement}>
        <button
          type={type}
          disabled={disabled}
          onClick={onClick}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0px 5px",
            ...style,
          }}
          className={`btn  ${className || "btn-light"}`}
          form={form}
        >
          {leftIcon} {text}
        </button>
      </Tooltip>
    );

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0px 5px",
        ...style,
      }}
      className={`btn  ${className || "btn-light"}`}
      form={form}
    >
      {leftIcon} {text}
    </button>
  );
}
